import Modal from "../../../common/Modal";
import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import { add } from "date-fns";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeleteReservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const {confirmDeleteReservationId, setConfirmDeleteReservationId, setCurrentDay} = useAdmin()

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            await AdminService.deleteReservation(confirmDeleteReservationId!)
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            setMessage({
                type: 'success',
                content: 'Reservation successfully deleted'
            })
            setTimeout(() => setMessage(undefined), 2500)
            setConfirmDeleteReservationId(undefined)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Are you sure you want to delete this reservation?</h1>
            <p>This action cannot be undone.</p>
            {/* Buttons for confirming or cancelling the deletion would go here */}
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                >Delete</button>
                <button
                onClick={() => setConfirmDeleteReservationId(undefined)}
                type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                >Cancel</button>
            </div>
            <div className="close"
            onClick={() => setConfirmDeleteReservationId(undefined)}
            >
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}
